import { useMemo } from 'react';

import { Tkv2PDF } from '../../tkv2PDF/types.ts';
import { buildPdfReportData } from '../builders/buildPdfReportData.ts';
import { useAppraisalReportData } from './useAppraisalReportData.tsx';

/**
 * Hook that returns only the PDF-specific data.
 * Use this when you only need PDF generation data.
 */
export const usePdfReportData = (): {
  data: Tkv2PDF;
  hasCompletedPhotoFetch: boolean;
} => {
  const coreData = useAppraisalReportData();
  const data = useMemo(() => buildPdfReportData(coreData), [coreData]);

  return { data, hasCompletedPhotoFetch: coreData.hasCompletedPhotoFetch };
};
